import Cookies from 'js-cookie'

const TokenKey = 'yuanlai-token'
const routerKey = 'routerKey'
const unameKey = 'unameKey'
const areaId = 'areaIdData'
const orgCode = 'orgCodeData'
const FlagKey = 'flag'

// export function getToken() {
//   return Cookies.get(TokenKey)
// }

// export function setToken(token) {
//   return Cookies.set(TokenKey, token)
// }

// export function removeToken() {
//   return Cookies.remove(TokenKey)
// }

export function getToken() {
  return Cookies.get(TokenKey)
  // return sessionStorage.getItem(TokenKey)
  // return localStorage.getItem(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
  // return sessionStorage.setItem(TokenKey,token)
  // return localStorage.setItem(TokenKey,token)
}
export function removeToken() {
  return Cookies.remove(TokenKey)
  // return sessionStorage.removeItem(TokenKey)
  // return localStorage.removeItem(TokenKey)
}

export function getFlag() {
  return localStorage.getItem(FlagKey)
}

export function setFlag(flag) {
  return localStorage.setItem(FlagKey, flag)
}
export function removeFlag() {
  return localStorage.removeItem(FlagKey)
}

export function setRouter(router) {
  // return sessionStorage.setItem(routerKey,router)
  return localStorage.setItem(routerKey, router)
}
export function getRouter() {
  // return sessionStorage.getItem(routerKey)
  return localStorage.getItem(routerKey)
}

export function removeRouter() {
  // return sessionStorage.removeItem(routerKey)
  return localStorage.removeItem(routerKey)
}

export function setUname(uname) {
  // return sessionStorage.setItem(unameKey,uname)
  return localStorage.setItem(unameKey, uname)
}
export function getUname() {
  // return sessionStorage.getItem(unameKey)
  return localStorage.getItem(unameKey)
}

export function removeUname() {
  // return sessionStorage.removeItem(unameKey)
  return localStorage.removeItem(unameKey)
}

export function setAreaId(area) {
  return localStorage.setItem(areaId, area)
}
export function getAreaId() {
  return localStorage.getItem(areaId)
}

export function removeAreaId() {
  return localStorage.removeItem(areaId)
}

export function setOrgCode(code) {
  return localStorage.setItem(orgCode, code)
}
export function getOrgCode() {
  return localStorage.getItem(orgCode)
}

export function removeOrgCode() {
  return localStorage.removeItem(orgCode)
}
